import axios from "axios";
const host = process.env.REACT_APP_API_URL;
const token = localStorage.getItem("token");
export async function editGradeApi(values, obj) {
  const res = await axios.put(
    `${host}api/tasks/${values.taskId}/grade/${values.userId}/edit`,
    obj, {
      headers: {
        token,
      },
    }
  );
  /*
  const res = await axios({
    url: host + "api/tasks/" + values.taskId + "/grade/" + values.userId + "/edit",
    method: "PUT",
    headers: { token: token },
    data: obj,
  });*/
  return res;
}

export async function addGradeApi(values) {
  const res = await axios.post(
    `${host}api/tasks/${values.taskId}/grade/${values.userId}/add`,
    values, {
      headers: {
        token,
      },
    }
  );
  /*
  const res = await axios({
    url: host + "api/tasks/" + values.taskId + "/grade/" + values.userId + "/add",
    method: "POST",
    headers: { token: token },
    data: values,
  });*/
  return res;
}

export async function getMenteeTasks() {
  const res = await axios.get(`${host}api/tasks/assigned`, {
    headers: { token: token, "Content-Type": "application/json" },
  });
  return res;
}

export async function getAdminTasks() {
  const res = await axios.get(`${host}api/general/domains`, {
    headers: { token: token, "Content-Type": "application/json" },
  });
  return res;
}

export async function addTaskApi(formData) {
  const res = await axios.post(`${host}api/tasks/add`, formData, {
    headers: { token: token, "Content-Type": "multipart/form-data" },
  });
  return res;
}

export async function editTaskApi(formData) {
  const res = await axios.post(`${host}api/tasks/update`, formData, {
    headers: { token: token, "Content-Type": "multipart/form-data" },
  });
  return res;
}

export async function subAllowedApi(taskId) {
  const res = await axios.post(
    `${host}api/missionControl/taskSubmission/allow`, { taskId }, {
      headers: { token: token, "Content-Type": "application/json" },
    }
  );
  return res;
}

export async function deleteSubFileApi(taskId) {
  const res = await axios.post(
    `${host}api/tasks/deleteSubFile/`, { taskId: taskId }, {
      headers: { token },
    }
  );
  /*
  const res = await axios({
    url: host + "api/tasks/deleteSubFile/",
    method: "POST",
    headers: { token: token },
    data: { taskId: taskId },
  });*/
  return res;
}

export async function deleteSubApi(subId) {
  const res = await axios.delete(`${host}api/tasks/deleteSub/${subId}`, {
    headers: { token },
  });
  /*
  const res = await axios({
    url: host + "api/tasks/deleteSub/" + String(subId),
    method: "DELETE",
    headers: { token: token },
  });*/
  return res;
}

export async function subNotAllowedApi(taskId) {
  const res = await axios.post(
    `${host}api/missionControl/taskSubmission/notAllow`, { taskId }, {
      headers: { token: token, "Content-Type": "application/json" },
    }
  );
  return res;
}
export async function showResultsApi(taskId) {
  const res = await axios.post(
    `${host}api/missionControl/taskResult`, { taskId }, {
      headers: { token: token, "Content-Type": "application/json" },
    }
  );
  return res;
}

export async function submitTaskApi(formData) {
  const res = await axios.post(`${host}api/tasks/submit`, formData, {
    headers: { token: token, "Content-Type": "multipart/form-data" },
  });
  return res;
}

export async function getTask(id) {
  const res = await axios.get(`${host}api/tasks/select/${id}`, {
    headers: { token: token, "Content-Type": "application/json" },
  });
  return res;
}

export async function deleteTaskApi(taskId) {
  const res = await axios.delete(`${host}api/tasks/delete`, {
    headers: { token: token, "Content-Type": "application/json" },
    data: { taskId: taskId },
  });
  return res;
}

export async function fetchSubmissionsApi() {
  const res = await axios.get(`${host}api/tasks/readsub`, {
    headers: { token },
  });
  /*
  const res = await axios({
    url: host + "api/tasks/readsub",
    method: "GET",
    headers: { token: token },
  });*/
  return res;
}
export async function fetchMenteeSubmissionsApi() {
  const res = await axios.get(`${host}api/tasks/submissions`, {
    headers: { token },
  });
  /*
  const res = await axios({
    url: host + "api/tasks/submissions",
    method: "GET",
    headers: { token: token },
  });*/
  return res;
}